import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useNavigate } from 'react-router-dom'
import { styled } from 'styled-components'
import { LikeProductItem } from '../../@types/product'
import { getLikeProducts } from '../../api/product'
import { Button } from '../../components/Button'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import MyshoppingProductHeader from '../../components/myshopping/ProductHeader'
import MyShoppingProductList from '../../components/myshopping/ProductList'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'

export default function Wishlist() {
  const title = 'likeList'
  const likeCount = 0
  const navigate = useNavigate()
  const [items, setItems] = useState<LikeProductItem[]>([])
  const [type, setType] = useState<string>('thumb')
  const { isAppView } = useAppContext()
  const { setIsLottie, hasAccessToken } = useCommonContext()

  useEffect(() => {
    if (hasAccessToken) {
      getLikeProducts(1)
        .then((res) => {
          setIsLottie(false)
          setItems(res.data.items)
        })
        .catch((err) => console.log(err))
    } else {
      setIsLottie(false)
    }
    // getAccessToken().then((res) => console.log(res.data));
  }, [])

  // FIXME: 상위 로직 리팩토링 테스트 필요합니다.
  // useEffect(() => {
  //   const fetchLikeProducts = async () => {
  //     if (accessToken) {
  //       try {
  //         const res = await getLikeProducts(1);
  //         setItem(res.data.items);
  //       } catch (err) {
  //         console.log(err);
  //       }
  //     }
  //     setIsLottie(false);
  //   };
  // }, [accessToken]);

  // 찜한 상품이 없을 때 박스 높이 조절
  useEffect(() => {
    const contentsWrap = document.querySelector('.contents_wrap')
    items?.length === 0 ? contentsWrap?.classList.add('full') : contentsWrap?.classList.remove('full')
  }, [])

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>찜한 목록</PageTitle>

            {items?.length !== 0 ? (
              <MyShoppingProductList title={title} />
            ) : (
              <>
                <NoContentWrap>
                  <MyshoppingProductHeader
                    totalCount={likeCount}
                    type={type}
                    setType={setType}
                  ></MyshoppingProductHeader>
                  <div className='no_content_wrap'>
                    <div className='no_content'>
                      <p className='title'>찜한 목록에 상품이 없습니다.</p>
                      <p className='sub_txt'>
                        살까?말까? 망설여지는 상품들을
                        <br />
                        일단 여기에 모아보세요.
                      </p>
                      <button
                        onClick={() => {
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.onClose, {
                              eventType: 999,
                            })
                          } else {
                            navigate('/')
                          }
                        }}
                      >
                        쇼핑 계속하기
                      </button>
                    </div>
                  </div>
                  {/* <NoContentCotentWrap2>
                    <NoContentTitle>
                      찜한 목록에 상품이 없습니다.
                    </NoContentTitle>
                    <NoContentContent>
                      살까?말까? 망설여지는 상품들을
                      <br />
                      일단 여기에 모아보세요.
                    </NoContentContent>
                    <NoContentBtn
                      onClick={() => {
                        navigate('/');
                      }}
                    >
                      쇼핑 계속하기
                    </NoContentBtn>
                  </NoContentCotentWrap2> */}
                </NoContentWrap>
                <CautionWrap>
                  <CautionContent>
                    30일이 지난 상품은 찜한 목록에서 자동 삭제됩니다.
                    <br />
                    찜한 목록의 상품을 장바구니 이동 시 할인금액 확인 및 주문이 가능합니다.
                  </CautionContent>
                </CautionWrap>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export const NoContentCotentWrap2 = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 120px 0 160px 0;
  & img {
    width: 85px;
    height: 85px;
  }
  @media screen and (min-width: 768px) {
    & img {
      width: 108px;
      height: 108px;
    }
  }
`

export const NoContentContent = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: var(--colGray5);
  text-align: center;
  margin-bottom: 20px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`
export const NoList = styled(NoContentContent)`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
    margin-top: 0;
  }
`

export const CautionWrap = styled.div`
  padding: 20px;
  @media screen and (min-width: 768px) {
    padding: 20px 0;
  }
`
export const CautionContent = styled(NoContentContent)`
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  font-weight: 400;
  margin-bottom: 0;
  @media screen and (min-width: 768px) {
    color: var(--colGray6);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
  }
`

export const NoContentWrap = styled.div`
  /* flex: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%; */
  flex: 1 1 0%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0 20px;

  @media screen and (min-width: 768px) {
    display: flex;
    padding: 0;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
`

export const NoContentContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const NoContentTitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 8px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`

export const NoContentBtn = styled(Button)`
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  padding: 12px 35px;
  color: var(--colWhite);
  background: var(--colBlack);
  border-radius: 76px;
  line-height: 20px;
  /* margin-top: 20px; */
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    padding: 14px 40px;
    margin-top: 32px;
    cursor: pointer;
  }
`
